import React from 'react';
import { Chip } from '@mui/material';
import {
  CheckCircleOutlined as CheckCircleIcon,
  WarningAmberOutlined as WarningIcon,
  CancelOutlined,
  InfoOutlined as InfoIcon,
} from '@mui/icons-material';

const StatusChip = ({
  color = 'default',
  label,
  icon,
  size = 'small',
  variant = 'filled',
  className,
  sx,
  onClick,
  disabled = false,
}) => {
  // Default icons for each color
  const DEFAULT_ICONS = {
    info: <InfoIcon fontSize="small" />,
    error: <CancelOutlined fontSize="small" />,
    warning: <WarningIcon fontSize="small" />,
    success: <CheckCircleIcon fontSize="small" />,
    default: <InfoIcon fontSize="small" />,
  };

  // Get default icon based on color
  const defaultIcon = DEFAULT_ICONS[color] || DEFAULT_ICONS.default;

  // Generate styles for large size
  const chipStyles =
    size === 'large'
      ? {
          fontSize: '1.1rem',
          height: '36px',
          '& .MuiChip-label': {
            fontSize: '1.1rem',
            px: 2.5,
            py: 0.75,
          },
          '& .MuiChip-icon': {
            fontSize: '1.2rem',
          },
        }
      : {};

  return (
    <Chip
      label={label}
      icon={icon === 'none' ? undefined : icon || defaultIcon}
      size={size === 'large' ? 'medium' : size}
      variant={variant}
      color={color}
      className={className}
      onClick={onClick}
      disabled={disabled}
      sx={{
        ...chipStyles,
        ...sx,
      }}
    />
  );
};

export default StatusChip;
